import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type ConversionsAction = ActionType<typeof actions>;

export type MetricType =
  | "searches"
  | "clicks"
  | "unique_clicks"
  | "bookings"
  | "sales"
  | "btr"
  | "ctr"
  | "str"
  | "percent_successful_responses"
  | "percent_errors_responses"
  | "percent_zeros_responses"
  | "percent_timeouts"
  | "productivity"
  | "response_duration";

export type CompareType = "1d" | "1w" | "1m" | "1y";

export interface ConversionChartsPayload {
  metric: MetricType;
  compare: CompareType;
}

export interface ConversionPercentsValues {
  percentSuccessfulResponses: number;
  percentErrorsResponses: number;
  percentZerosResponses: number;
  percentTimeouts: number;
}

interface ConversionTimestamp {
  timestamp: string;
}

export interface ConversionBaseItem extends ConversionPercentsValues {
  searches: number;
  clicks: number;
  uniqueClicks: number;
  ctr: number;
  bookings: number;
  btr: number;
  sales: number;
  predictedSales: number;
  productivity: number;
  successfulResponses: number;
  errorsResponses: number;
  zerosResponses: number;
  timeouts: number;
  str: number;
  responseDuration: number;
}

export interface ConversionItem extends ConversionBaseItem, ConversionTimestamp {}

export interface ConversionChartItem extends ConversionTimestamp {
  value: number;
  compare: number;
}

export interface PercentValue {
  value: number;
  percent: number;
}

export interface ConversionSearchResultChartItem extends ConversionTimestamp {
  searches: number;
  successfulResponses: PercentValue;
  errorsResponses: PercentValue;
  zerosResponses: PercentValue;
  timeouts: PercentValue;
}

export enum ConversionsActionTypes {
  TABLE_FETCH_REQUEST = "@Conversions/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Conversions/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Conversions/TABLE_FETCH_ERROR",

  TABLE_SUMMARY_FETCH_REQUEST = "@Conversions/TABLE_SUMMARY_FETCH_REQUEST",
  TABLE_SUMMARY_FETCH_SUCCESS = "@Conversions/TABLE_SUMMARY_FETCH_SUCCESS",
  TABLE_SUMMARY_FETCH_ERROR = "@Conversions/TABLE_SUMMARY_FETCH_ERROR",

  CHART_FETCH_REQUEST = "@Conversions/CHART_FETCH_REQUEST",
  CHART_FETCH_SUCCESS = "@Conversions/CHART_FETCH_SUCCESS",
  CHART_FETCH_ERROR = "@Conversions/CHART_FETCH_ERROR",

  CHART_SEARCH_RESULTS_FETCH_REQUEST = "@Conversions/CHART_SEARCH_RESULTS_FETCH_REQUEST",
  CHART_SEARCH_RESULTS_FETCH_SUCCESS = "@Conversions/CHART_SEARCH_RESULTS_FETCH_SUCCESS",
  CHART_SEARCH_RESULTS_FETCH_ERROR = "@Conversions/CHART_SEARCH_RESULTS_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Conversions/GENERATE_REPORT_REQUEST",
}

export interface ConversionsState {
  readonly count: number;
  readonly items: ConversionItem[];
  readonly summary?: ConversionBaseItem;
  readonly summaryIsLoading: boolean;
  readonly dataIsLoading: boolean;
  readonly chartItems: ConversionChartItem[];
  readonly chartDataIsLoading: boolean;
  readonly chartSearchResultsItems: ConversionSearchResultChartItem[];
  readonly chartSearchResultsDataIsLoading: boolean;
}
